const landingPage = () => import(/* webpackChunkName: "landingPage" */ `@/pages/landing/${process.env.APP_ID}/landing`)
const landingFeatures = () => import(/* webpackChunkName: "landingFeatures" */ `@/pages/landing/${process.env.APP_ID}/landing-features`)
const landingCommitments = () => import(/* webpackChunkName: "landingCommitments" */ `@/pages/landing/${process.env.APP_ID}/landing-commitments`)

const landingPagePro = () => import(/* webpackChunkName: "landingPagePro" */ '@/pages/landing-pro')
const landingPageProAdvisor = () => import(/* webpackChunkName: "landingPageProAdvisor" */ '@/pages/landing-pro/advisor')
const landingPageProCustomers = () => import(/* webpackChunkName: "landingPageProCustomers" */ '@/pages/landing-pro/customers')

const loginPage = () => import(/* webpackChunkName: "loginPage" */ '@/pages/login')
const authenticatedPage = () => import(/* webpackChunkName: "authenticatedPage" */ '@/pages/authenticated/index')
const lobbyContainer = () => import(/* webpackChunkName: "lobbyContainer" */ '@/components/lobby-container')
const dashboardPage = () => import(/* webpackChunkName: "dashboardPage" */ '@/pages/dashboard')
const dashboardOverview = () => import(/* webpackChunkName: "dashboardOverview" */ '@/pages/dashboard/dashboard-overview')
const dashboardContracts = () => import(/* webpackChunkName: "dashboardContracts" */ '@/pages/dashboard/dashboard-contracts')
const dashboardLoansOverview = () => import(/* webpackChunkName: "dashboardLoansOverview" */ '@/pages/dashboard/dashboard-loans-overview')
const dashboardLoansContracts = () => import(/* webpackChunkName: "dashboardLoansContracts" */ '@/pages/dashboard/dashboard-loans-contracts')

const contractPage = () => import(/* webpackChunkName: "contractPage" */ '@/pages/contract')
const contractOverview = () => import(/* webpackChunkName: "contractOverview" */ '@/pages/contract/contract-overview')
const contractProject = () => import(/* webpackChunkName: "contractProject" */ '@/pages/contract/contract-project')
const contractAllocation = () => import(/* webpackChunkName: "contractAllocation" */ '@/pages/contract/contract-allocation')
const contractInvestments = () => import(/* webpackChunkName: "contractInvestments" */ '@/pages/contract/contract-investments')
const contractSettings = () => import(/* webpackChunkName: "contractSettings" */ '@/pages/contract/contract-settings')
const contractDetails = () => import(/* webpackChunkName: "contractDetails" */ '@/pages/contract/contract-details')
const contractDocuments = () => import(/* webpackChunkName: "contractDocuments" */ '@/pages/contract/contract-documents')
const contractInformations = () => import(/* webpackChunkName: "contractInformations" */ '@/pages/contract/contract-informations')
const contractInfoNeeded = () => import(/* webpackChunkName: "contractInfoNeeded" */ '@/pages/contract/contract-info-needed')

const realestatePage = () => import(/* webpackChunkName: "realestatePage" */ '@/pages/real-estate')

const deleteProfile = () => import(/* webpackChunkName: "deleteProfile" */ '@/pages/delete-profile')

const analysePage = () => import(/* webpackChunkName: "analysePage" */ '@/pages/analyse')
const analyseAllocation = () => import(/* webpackChunkName: "analyseAllocation" */ '@/pages/analyse/analyse-allocation')
const analysePerf = () => import(/* webpackChunkName: "analysePerf" */ '@/pages/analyse/analyse-perf')
const analyseRisk = () => import(/* webpackChunkName: "analyseRisk" */ '@/pages/analyse/analyse-risk')
const analyseFees = () => import(/* webpackChunkName: "analyseFees" */ '@/pages/analyse/analyse-fees')
const analyseAdvices = () => import(/* webpackChunkName: "analyseAdvices" */ '@/pages/analyse/analyse-advices')

const arbitrationPage = () => import(/* webpackChunkName: "arbitrationPage" */ '@/pages/arbitration')
const arbitrationStart = () => import(/* webpackChunkName: "arbitrationStart" */ '@/pages/arbitration/arbitration-start')
const arbitrationMarket = () => import(/* webpackChunkName: "arbitrationMarket" */ '@/pages/arbitration/arbitration-market')
const arbitrationOptimize = () => import(/* webpackChunkName: "arbitrationOptimize" */ '@/pages/arbitration/arbitration-optimize')

const userPage = () => import(/* webpackChunkName: "userPage" */ '@/pages/user.vue')
const userInfos = () => import(/* webpackChunkName: "userInfos" */ '@/pages/user/user-infos')
const userProfile = () => import(/* webpackChunkName: "userProfile" */ '@/pages/user/user-profile')
const userAccounts = () => import(/* webpackChunkName: "userAccounts" */ '@/pages/user/user-accounts')
const userGoods = () => import(/* webpackChunkName: "userGoods" */ '@/pages/user/user-goods')
const userNotifications = () => import(/* webpackChunkName: "userNotifications" */ '@/pages/user/user-notifications')
const userPayment = () => import(/* webpackChunkName: "userPayment" */ '@/pages/user/user-payment')

const registerPage = () => import(/* webpackChunkName: "registerPage" */ '@/pages/register.vue')
const confirmationPage = () => import(/* webpackChunkName: "confirmationPage" */ '@/pages/confirmation.vue')
const resetPasswordPage = () => import(/* webpackChunkName: "resetPasswordPage" */ '@/pages/reset-password.vue')

const subscriptionPage = () => import(/* webpackChunkName: "subscriptionPage" */ '@/pages/subscription.vue')
const paymentPage = () => import(/* webpackChunkName: "paymentPage" */ '@/pages/payment.vue')

const accountsAdd = () => import(/* webpackChunkName: "accountsAdd" */ '@/pages/accounts/add.vue')
const accountsAddIndex = () => import(/* webpackChunkName: "accountsAddIndex" */ '@/pages/accounts/add/index.vue')
const accountsAddForm = () => import(/* webpackChunkName: "accountsAddForm" */ '@/pages/accounts/add/form.vue')
const accountsLoad = () => import(/* webpackChunkName: "accountsLoad" */ '@/pages/accounts/load.vue')

const realEstateAddForm = () => import(/* webpackChunkName: "realEstateAddForm" */ '@/pages/accounts/real-estate/form.vue')
const realEstateAddFormMan = () => import(/* webpackChunkName: "realEstateAddForm" */ '@/pages/accounts/real-estate/form-man.vue')
const realEstateEvaluate = () => import(/* webpackChunkName: "realEstateEvaluate" */ '@/pages/accounts/real-estate/evaluate.vue')
const realEstateEvaluateMan = () => import(/* webpackChunkName: "realEstateEvaluate" */ '@/pages/accounts/real-estate/evaluate-man.vue')
const realEstateSettings = () => import(/* webpackChunkName: "realEstateSettings" */ '@/pages/contract/realestate/realestate-settings.vue')

const profileFill = () => import(/* webpackChunkName: "profileFill" */ '@/pages/accounts/profile')
const profileFillRisk = () => import(/* webpackChunkName: "profileFillRisk" */ '@/pages/accounts/profile/questions')
const profileFillInfos = () => import(/* webpackChunkName: "profileFillInfos" */ '@/pages/accounts/profile/infos')
const profileResult = () => import(/* webpackChunkName: "profileResult" */ '@/pages/accounts/profile/result')

const accountsRisk = () => import(/* webpackChunkName: "accountsRisk" */ '@/pages/accounts/risk')

const advisoryPage = () => import(/* webpackChunkName: "advisoryPage" */ '@/pages/advisory/index')
const advisoryLoginPage = () => import(/* webpackChunkName: "advisoryLoginPage" */ '@/pages/advisory/login')
const advisoryCustomers = () => import(/* webpackChunkName: "advisoryCustomers" */ '@/pages/advisory/advisory-customers')
const advisoryCustomersList = () => import(/* webpackChunkName: "advisoryCustomersList" */ '@/pages/advisory/customers-list')
const advisoryCustomersAdd = () => import(/* webpackChunkName: "advisoryCustomersAdd" */ '@/pages/advisory/customers-add')
const advisoryCustomerInfos = () => import(/* webpackChunkName: "advisoryCustomerInfos" */ '@/pages/advisory/customer-infos')
const customerOverview = () => import(/* webpackChunkName: "customerOverview" */ '@/pages/advisory/customer/overview')
const customerInteractions = () => import(/* webpackChunkName: "customerInteractions" */ '@/pages/advisory/customer/interactions')

const fundPage = () => import(/* webpackChunkName: "fundPage" */ '@/pages/fund')

const contractCard = () => import(/* webpackChunkName: "contractCard" */ '@/pages/contract-card')

const CGUPage = () => import(/* webpackChunkName: "CGUPage" */ `@/pages/cgu/${process.env.APP_ID}/index`)
const legalNoticePage = () => import(/* webpackChunkName: "legalNoticePage" */ '@/pages/legal-notice')

const error500 = () => import(/* webpackChunkName: "error500" */ '@/pages/errors/500')
const error404 = () => import(/* webpackChunkName: "error404" */ '@/pages/errors/404')

const pages = {
  landingPage,
  landingFeatures,
  landingCommitments,
  landingPagePro,
  landingPageProAdvisor,
  landingPageProCustomers,
  loginPage,
  authenticatedPage,
  lobbyContainer,
  dashboardPage,
  dashboardOverview,
  dashboardContracts,
  dashboardLoansOverview,
  dashboardLoansContracts,
  contractPage,
  contractOverview,
  contractProject,
  contractAllocation,
  contractInvestments,
  contractSettings,
  contractDetails,
  contractDocuments,
  contractInformations,
  contractInfoNeeded,
  realestatePage,
  deleteProfile,
  analysePage,
  analyseAllocation,
  analysePerf,
  analyseRisk,
  analyseFees,
  analyseAdvices,
  arbitrationPage,
  arbitrationStart,
  arbitrationMarket,
  arbitrationOptimize,
  userPage,
  userInfos,
  userProfile,
  userAccounts,
  userGoods,
  userNotifications,
  userPayment,
  registerPage,
  confirmationPage,
  resetPasswordPage,
  subscriptionPage,
  paymentPage,
  accountsAdd,
  accountsAddIndex,
  accountsAddForm,
  accountsLoad,
  realEstateAddForm,
  realEstateAddFormMan,
  realEstateEvaluate,
  realEstateEvaluateMan,
  realEstateSettings,
  profileFill,
  profileFillRisk,
  profileFillInfos,
  profileResult,
  accountsRisk,
  advisoryPage,
  advisoryLoginPage,
  advisoryCustomers,
  advisoryCustomersList,
  advisoryCustomersAdd,
  advisoryCustomerInfos,
  customerOverview,
  customerInteractions,
  fundPage,
  contractCard,
  CGUPage,
  legalNoticePage,
  error500,
  error404
}

export default pages
